import React from "react";
import { Container, Message } from "./styles";

const LoadingScreen = () => {
  return (
    <Container>
      <Message>Loading image...</Message>
    </Container>
  );
};

export default LoadingScreen;
